import { Routes } from '@angular/router';
import { authRoutes } from './features/auth/auth.routes';
import { authGuard } from './core/guards/auth.guard';


export const routes: Routes = [
    {
        path: '',
        canActivate: [authGuard],
        loadComponent: () =>
            import('./layout/default-layout/default-layout')
                .then(m => m.DefaultLayout),
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'customer-record'
            },
            {
                path: 'customer-record',
                loadChildren: () =>
                    import('./features/customer-record/customer.routes')
                        .then(m => m.CUSTOMER_RECORD_ROUTES)
            },
            {
                path: 'my-account',
                loadChildren: () =>
                    import('./features/my-account/my-account.routes')
                        .then(m => m.MyAccountRoutes)
            }
        ]
    },
    ...authRoutes
];

